/**
 * Ignition arcs age out.  An arc is drawn at full strength for a while after
 * it fires, then fades to a faint trace, so the map reads as "what is
 * transferring now" instead of the run's whole history piling up into a mat.
 * Shared by the project page (UrbanIgnitionEdgesLayer) and the story-map
 * animation so both fade the same way.
 */
export type MapExpression = unknown[];

/** Arcs younger than this are at full strength. */
export const URBAN_EDGE_FADE_FULL_S = 30 * 60;
/** By this age an arc has faded to the floor. */
export const URBAN_EDGE_FADE_END_S = 2 * 60 * 60;
/** Opacity an old arc keeps, so the history is still traceable. */
export const URBAN_EDGE_FADE_FLOOR = 0.15;

/** 1 while fresh, easing to the floor by the end age. `ageS` is an expression in seconds. */
export const urbanEdgeAgeFactor = (ageS: MapExpression): MapExpression => [
  "interpolate", ["linear"], ageS,
  URBAN_EDGE_FADE_FULL_S, 1,
  URBAN_EDGE_FADE_END_S, URBAN_EDGE_FADE_FLOOR,
];

/**
 * The zoom fade-in the edge layers already use, scaled by age.  Mapbox wants
 * the zoom interpolation outermost; its outputs may be data-driven.
 */
export const urbanEdgeOpacity = (
  zoomHidden: number,
  zoomFull: number,
  peak: number,
  ageS: MapExpression,
): MapExpression => [
  "interpolate", ["linear"], ["zoom"],
  zoomHidden, 0,
  zoomFull, ["*", peak, urbanEdgeAgeFactor(ageS)],
];
